import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
import { PreviewQuestion, SerializedDate } from './get-activity';
export const GetPreviewProjectParams = z.object({
    projectSlug: z.string().min(1),
});
export const AppliedProjectTag = z.object({
    value: z.string(),
    type: z.enum(['TOPIC', 'ROLE', 'APPLICATION']),
});
export const GetPreviewProjectResponse = z.object({
    activity_id: z.number(),
    activity_session_id: z.null(),
    title: z.string(),
    summary: z.string(),
    slug: z.string(),
    latest_submission: z.null(),
    exercise: z.object({
        id: z.number(),
        created_at: SerializedDate,
        updated_at: SerializedDate,
        slug: z.string(),
        topic: z.string(),
        name: z.string(),
        summary: z.string(),
        description: z.string(),
        lesson: z.string(),
        is_draft: z.boolean(),
        tags: z.array(AppliedProjectTag),
        image_url: z.string().nullable(),
        metadata: z.record(z.unknown()).nullable(),
        company_id: z.number().nullable(),
        objectives: z.unknown(),
        questions: z.array(PreviewQuestion),
    }),
    content_slug: z.string(),
    content_title: z.string(),
});
export const getPreviewProjectRoute = {
    version: 1,
    method: 'GET',
    path: '/preview/projects/{projectSlug}',
    name: 'get-preview-project',
    request: { params: GetPreviewProjectParams },
    responses: {
        200: GetPreviewProjectResponse,
        400: HttpErrorResponse,
    },
};
